import { IonChip, IonLabel, IonText } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { FilterFileTypes, setFilterModal } from "../../../store/fileTypes";
import { RootState } from "../../../store/rootReducer";

export const FilterChip = () => {
  const filterList = useSelector((state: RootState) => state.fileTypes.filterList);
  const dispatch = useDispatch();
  return (
    <IonChip
      onClick={() => dispatch(setFilterModal(true))}
      outline
      color={filterList?.length ? "primary" : "medium"}
    >
      <IonLabel class="ion-text-nowrap">
        {filterList?.length ? (
          <IonText color="primary" style={{ fontWeight: 600 }}>
            <span>Mostrando: </span>
            {filterList?.map(
              (typeItem: FilterFileTypes, index) => typeItem.name + (filterList?.length === index + 1 ? "" : ", ")
            )}
          </IonText>
        ) : (
          <span>Mostrando: Todos</span>
        )}
      </IonLabel>
    </IonChip>
  );
};
